// v-digits.js — só dígitos, sem recursão
export default {
  mounted(el) {
    let programmatic = false
    let composing = false

    const emitInput = () => {
      programmatic = true
      el.dispatchEvent(new Event('input', { bubbles: true }))
    }

    const onInput = () => {
      if (programmatic || composing) {
        programmatic = false
        return
      }
      const before = el.value
      const cleaned = before.replace(/\D/g, '')
      if (cleaned !== before) {
        el.value = cleaned
        emitInput() // sincroniza v-model apenas quando alteramos programaticamente
      }
      // se não mudou, nada a fazer: o input nativo já atualizou o v-model
    }

    const onPaste = () => {
      // deixa colar e saneia no próximo frame
      requestAnimationFrame(onInput)
    }

    const onCompStart = () => { composing = true }
    const onCompEnd   = () => { composing = false; onInput() }

    el.addEventListener('input', onInput)
    el.addEventListener('paste', onPaste)
    el.addEventListener('compositionstart', onCompStart)
    el.addEventListener('compositionend', onCompEnd)

    // ajuda no mobile
    el.setAttribute('inputmode', 'numeric')
    el.setAttribute('pattern', '[0-9]*')

    // guarda refs para remover
    el._digits = { onInput, onPaste, onCompStart, onCompEnd }
  },

  unmounted(el) {
    const h = el._digits
    if (!h) return
    el.removeEventListener('input', h.onInput)
    el.removeEventListener('paste', h.onPaste)
    el.removeEventListener('compositionstart', h.onCompStart)
    el.removeEventListener('compositionend', h.onCompEnd)
    delete el._digits
  }
}
